import { combineReducers } from 'redux'
import { auth } from './auth'
import { clients } from './clients'
import { dialogs } from './dialogs'
import { filters } from './filters'
import { detailPortfolioState } from './portfolio'
import { securities } from './securities'
import { orders } from './orders'
import { traderDiaries } from './traderDiary'
import { currency } from './currency'
import { market } from './market'
import { useractions } from './useractions'
import { roles } from './role'
import { investments } from './investment'
import { loading } from './loading'
import { labelState } from './label'
import { noteState } from './note'
import { clientFiles } from './clientFile'
import { users } from './user'
import { cpty } from './cpty'
import { territories } from './territories'
import { persons } from './persons'
import { contracts } from './contract'

export const rootReducer = combineReducers({
  auth,
  clients,
  dialogs,
  filters,
  detailPortfolioState,
  securities,
  orders,
  traderDiaries,
  currency,
  useractions,
  loading,
  roles,
  investments,
  market,
  labelState,
  noteState,
  clientFiles,
  users,
  cpty,
  territories,
  persons,
  contracts
})

export type RootState = ReturnType<typeof rootReducer>
